let setCurrencyPrice = {
    install: (app, options) => {
        const currencyPrice = function (price  = 0, currency='USD', digits=2, is_round = false) {
          currency = currency.toUpperCase()
          if(currency === 'cop') {
              return `${app.config.globalProperties.$currencyFormat(price, currency, digits, is_round)} COP`
            }
            return app.config.globalProperties.$currencyFormat(price, currency, digits, is_round)
      }
    app.config.globalProperties.$currencyPrice = currencyPrice
    app.provide('currencyPrice', currencyPrice)
  }
}

export default setCurrencyPrice